import { useCreateBowelMovementMutation } from "../../../services/api/staticFormsApi";
import { useResidentContext } from "../../residents/provider/ResidentProvider";
import usePagination from "ui/molecules/pagination/usePagination";
import { useForm } from "react-hook-form";
import { BowelMovementRequest } from "../../../services/api/types/forms/requests/BowelMovementRequest";
import { useActionSignatureContext } from "../../actionSignature/providers/ActionSignatureProvider";
import { useDisplayToast } from "ui/hooks/useDisplayToast";
import { useBowelMovementsWithOffline } from "../../offline/hooks/useBowelMovementsWithOffline";

interface Props {
  onSuccess?: () => void;
}

export function useHandleBowelMovement({ onSuccess }: Props) {
  const { residentId } = useResidentContext();
  const { showActionSignatureModal } = useActionSignatureContext();
  const { showNewToast, showErrorToast, showOfflineToast } = useDisplayToast();
  const [triggerCreateBowelMovement] = useCreateBowelMovementMutation();

  const { currentPage, handlePageChange } = usePagination();

  const {
    data,
    isFetching: isHistoryLoading,
    meta,
  } = useBowelMovementsWithOffline({
    residentId,
    currentPage,
  });

  const {
    control,
    handleSubmit,
    formState: { isSubmitting, isDirty },
    watch,
  } = useForm<BowelMovementRequest>({
    defaultValues: {
      residentId,
      enema_suppositories_done: undefined,
      bowels_opened: undefined,
      voiding_place: undefined,
      voiding_place_description: "",
      stool_type: "",
      other_comments: "",
      password: "",
    },
  });

  const submit = handleSubmit(async (data) => {
    try {
      const response = await showActionSignatureModal({
        title: "Create Bowel Movement Log",
        description: "Please enter your password to create this log",
      });

      const body: BowelMovementRequest = {
        ...data,
        password: response.password,
        residentId: residentId!,
      };

      await triggerCreateBowelMovement(body).unwrap();
      showNewToast({
        title: "Bowel Movement logged successfully",
        message: "The log has been created successfully",
        type: "success",
      });
    } catch (e) {
      showOfflineToast(
        {
          title: "Bowel Movement saved offline",
        },
        () => showErrorToast(e),
      );
    }
    if (onSuccess) onSuccess();
  });

  return {
    data,
    control,
    isSubmitting,
    submit,
    isDirty,
    handlePageChange,
    isHistoryLoading,
    watch,
    meta,
  };
}
